module.exports = __webpack_public_path__ + "yogaImg3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yogaImg3.jpg
// module id = 303
// module chunks = 0